<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1100px"
      line-form
      :title="(isEdit?'审核':'查看')+' 其他应收单'"
      id-key="OtherReceivId"
      :data="data"
      :get-data-func="api.info"
      form-label-width="95px"
      @edit-opened="onEditOpened"
      @closed="onClosed"
    >
      <template slot="form">
        <el-row class="border">
          <el-row>
            <el-col :span="isMB?24:6">
              <el-form-item label="单据编号" prop="DocNo">
                <span class="detail-span">{{data.DocNo}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:6">
              <el-form-item label="单据日期" prop="DocDate">
                <span class="detail-span">{{$commonJs.toDateString(data.DocDate)}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:6">
              <el-form-item label="业务类型" prop="BusinessTypeId">
                <span class="detail-span">{{data.BusinessType}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:6">
              <el-form-item label="往来单位" prop="TradeUnitId">
                <span class="detail-span">{{data.TradeUnitName}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="isMB?24:6">
              <el-form-item label="收款到期日" prop="LastDate">
                <span class="detail-span">{{$commonJs.toDateString(data.LastDate)}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="isMB?24:6">
              <el-form-item label="经办人" prop="Manager">
                <span class="detail-span">{{data.ClerkName}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注" prop="Remark">
                <span class="detail-span">{{data.Remark}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
        <div class="row-tb-head" style="margin-top: 10px;">
          <span>单据明细</span>
        </div>
        <el-table ref="table" class="tb-c-head" show-summary :data="data.RpOtherReceivDts" border>
          <el-table-column label="摘要" align="center" min-width="200">
            <template slot-scope="{row}">{{row.Abstract}}</template>
          </el-table-column>
          <el-table-column label="项目" align="center" min-width="140">
            <template slot-scope="{row}">{{row.ItemName}}</template>
          </el-table-column>
          <el-table-column prop="Amount" label="金额" align="center" width="120" />
        </el-table>
      </template>
      <template slot="footer" slot-scope="{isLoading}">
        <template v-if="data.Status<2&&isEdit">
          <el-button size="mini" :loading="isLoading" type="success" @click="save('examine')">审 核</el-button>
        </template>
        <template v-if="data.Status==2">
          <el-button size="mini" :loading="isLoading" type="danger" @click="save('cancelExamine')">弃 审</el-button>
        </template>
        <el-button size="mini" @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api:require("@/api/fund/contactcash/orec").default,
      data: {
        OtherReceivId: 0,
        DocNo: "",
        DocDate: this.$commonJs.getToday(), //单据日期
        TradeUnitId: null, //往来单位Id
        TradeUnitName: "",
        BusinessTypeId: null, //业务类型
        BusinessType: "",
        LastDate: null, //付款到期日
        ClerkId: null, //经办人
        ClerkName: "",
        // Amount: null, //金额
        // TaxAmount: null, //税额
        // IncTaxAmount: null, //含税金额
        Remark: "",
        Status: 0,
        RpOtherReceivDts: [],
      },
      isMB: this.$store.state.isMB,
    };
  },
  methods: {
    onEditOpened(row) {
      this.isEdit = true;
    },
    save(type) {
      this.$refs.dialog.isLoading = true;
      this.api[type](this.data.OtherReceivId).then((res) => {
        this.$refs.dialog.isLoading = false;
        if (res.Code == 0) {
          this.$message.success(res.Msg);
          this.$emit("close-saved");
          this.close(true);
        } else {
          this.$message.error(res.Msg);
        }
      });
    },
    onClosed() {
      this.isEdit = false;
      this.data.RpOtherReceivDts = [];
    },
  },
};
</script> 